import { Stack, Button, Group, useComputedColorScheme } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import { ActionRequest, ActionResponse } from 'interfaces';
import { useState } from 'react';

export const ResolveResponseButton = ({
  request,
  response,
  onSatisfy,
  onCancel,
  openRejectDialog,
}: {
  request: ActionRequest;
  response: ActionResponse;
  onSatisfy: (
    request: ActionRequest,
    response: ActionResponse
  ) => Promise<void>;
  onCancel: (request: ActionRequest, response: ActionResponse) => Promise<void>;
  openRejectDialog: (request: ActionRequest, response: ActionResponse) => void;
}) => {
  const computedColorScheme = useComputedColorScheme('dark');
  const color = computedColorScheme === 'dark' ? 'white' : 'black';
  const [open, setOpen] = useState(false);

  return (
    <Stack gap={8} align="flex-end">
      <Button
        size="xs"
        variant="light"
        data-testid="resolve-button"
        onClick={() => setOpen((v) => !v)}
      >
        Resolve
      </Button>

      {open && (
        <Group gap={8} miw={'50%'}>
          <Button
            c={color}
            size="xs"
            leftSection={<IconCheck size={14} />}
            data-testid="resolve-satisfied"
            onClick={async () => {
              await onSatisfy(request, response);
              setOpen(false);
            }}
          >
            Satisfied
          </Button>
          <Button
            size="xs"
            c={color}
            color="red"
            data-testid="resolve-reject"
            onClick={async () => {
              openRejectDialog(request, response);
              setOpen(false);
            }}
          >
            Reject
          </Button>
          <Button
            size="xs"
            variant="default"
            c={color}
            leftSection={<IconX size={14} />}
            data-testid="resolve-cancel"
            onClick={async () => {
              await onCancel(request, response);
              setOpen(false);
            }}
          >
            Cancel
          </Button>
        </Group>
      )}
    </Stack>
  );
};
